var React = require('react');

function Chat348px (props) {
    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M47.292 47.956a1 1 0 0 1-1.121-.397L41.073 40H18c-2.306 0-4-1.836-4-4.143V30a1 1 0 1 1 2 0v5.857c0 1.204.978 2.183 2.182 2.183h23.451c.032 0 .059.015.091.018a1.038 1.038 0 0 1 .373.111.967.967 0 0 1 .152.103c.055.044.103.09.147.144.02.024.048.038.066.065L46 43.728V19.182A2.184 2.184 0 0 0 43.818 17H39a1 1 0 1 1 0-2.001h4.818A4.188 4.188 0 0 1 48 19.182V47a1 1 0 0 1-.708.956zM30 24.999H6.926l-5.097 7.559A1 1 0 0 1 0 31.999V4.181A4.187 4.187 0 0 1 4.182-.001h25.636A4.187 4.187 0 0 1 34 4.181v16.676c0 2.306-1.694 4.142-4 4.142zm2-20.818A2.184 2.184 0 0 0 29.818 2H4.182A2.183 2.183 0 0 0 2 4.181v24.547l3.538-5.247c.018-.027.046-.041.066-.066a.974.974 0 0 1 .145-.142c.05-.04.099-.075.155-.105a.996.996 0 0 1 .172-.069.982.982 0 0 1 .201-.041c.031-.003.058-.018.09-.018h23.451c1.203 0 2.182-.98 2.182-2.183V4.181z","key":1})]);
}

Chat348px.displayName = "Chat348px";

Chat348px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 48 48"};

module.exports = Chat348px;

Chat348px.default = Chat348px;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/48px/chat-3-48px.svg
// module id = 1131
// module chunks = 0